var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleFillPlusBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_74876",
    "data-name": "Group 74876",
    transform: "translate(-754 -582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    transform: "translate(754 582)",
    fill: "#fff",
    stroke: "#0f4c7d",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1794",
    "data-name": "Rectangle 1794",
    transform: "translate(760.808 586.539)",
    fill: "#fff",
    stroke: "#0f4c7d",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.513,
    height: 6.052,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.513,
    height: 5.052,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1795",
    "data-name": "Rectangle 1795",
    transform: "translate(764.59 588.808) rotate(90)",
    fill: "#fff",
    stroke: "#0f4c7d",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.513,
    height: 6.052,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.513,
    height: 5.052,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleFillPlusBlue);
export default __webpack_public_path__ + "static/media/CircleFillPlusBlue.8cbcf634d3c181bc6f1213798df4639d.svg";
export { ForwardRef as ReactComponent };